import React from "react";
import PropTypes from "prop-types";
import { Col, FormGroup, Label, Row } from "reactstrap";

export default function FieldRow({ label, children, hint }) {
  return (
    <FormGroup row className="mb-2">
      <Label sm={4} style={{ fontSize: "0.85rem", paddingTop: 6 }}>
        {label}
      </Label>
      <Col sm={8}>
        {children}
        {hint && (
          <small className="text-muted" style={{ fontSize: "0.75rem" }}>
            {hint}
          </small>
        )}
      </Col>
    </FormGroup>
  );
}

FieldRow.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  hint: PropTypes.string,
};

FieldRow.defaultProps = { hint: null };

export function Section({ title, children }) {
  return (
    <Row className="mb-2">
      <Col>
        <div
          style={{
            fontSize: "0.75rem",
            fontWeight: 600,
            textTransform: "uppercase",
            color: "#6c757d",
            borderBottom: "1px solid #dee2e6",
            paddingBottom: 2,
            marginBottom: 8,
          }}
        >
          {title}
        </div>
        {children}
      </Col>
    </Row>
  );
}

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
